export class ImportCategoryRequest {
  pCSID: string;
  pCategory: string;
  pIsPreview: boolean;

  constructor(init?: Partial<ImportCategoryRequest>) {
    Object.assign(this, init);
  }
}
